// src/components/Login.js
import { useState } from 'react';
import { auth } from '../../utils/config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom'
const Login = () => {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate()
  const updateUser = (event) => {
    setUser((prevUser) => ({
      ...prevUser,
      [event.target.name]: event.target.value,
    }));
  };

  const handleLogin = async () => {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, user.email, user.password);
        const loggedInUser = userCredential.user;
        console.log('Inicio de sesión exitoso', loggedInUser);
        navigate('/')
    } catch (error) {
      console.error('Error de inicio de sesión:', error.message);
    }
  };

  return (
    <div>
      <h2>Iniciar Sesión</h2>
      <label>Email:</label>
      <input
        type="email"
        name="email"
        value={user.email}
        onChange={updateUser}
      />
      <label>Contraseña:</label>
      <input
        type="password"
        name="password"
        value={user.password}
        onChange={updateUser}
      />
      <button onClick={handleLogin}>Iniciar Sesión</button>
    </div>
  );
};

export default Login;
